import { render, staticRenderFns } from "./fixBox.vue?vue&type=template&id=55ae6dba&scoped=true&"
import script from "./fixBox.vue?vue&type=script&lang=js&"
export * from "./fixBox.vue?vue&type=script&lang=js&"
import style0 from "./fixBox.vue?vue&type=style&index=0&id=55ae6dba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ae6dba",
  null
  
)

export default component.exports